// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"Search_searchBar__1OIh1"};